import { makeSx } from '../../../theme/_utils'
import { defaultPalette } from '../../../theme/idsTheme'
import { hexToRgba } from '../../../utils/commonUtils'

export default makeSx({
    cardsContainer: {
        display: 'flex',
        flexDirection: { md: 'column', lg: 'row' },
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        gap: '1rem',
        paddingTop: '1rem',
        paddingBottom: '1rem',
    },
    card: {
        width: 'auto',
        flex: 1,
        maxWidth: 'calc(28rem - 3rem) !important',
        minWidth: 'calc(23rem - 3rem)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '1.25rem',
        borderRadius: '1rem',
        boxShadow: `0px 5px 15px 0px ${defaultPalette.lightGrey.harder}, 0px 2px 4px 0px rgba(221, 225, 236, 0.25)`,
        border: `1px solid ${hexToRgba(defaultPalette.secondary.dark, 0.06)}`,
        '& .MuiCardContent-root:last-child': {
            paddingBottom: '0',
        },
    },
    cardContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '1rem',
    },
    cardTitle: {
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: { sm: '16px', md: '22px' },
        color: defaultPalette.typography.main,
        '& .MuiCardHeader-title': {
            marginBottom: 0,
        },
    },
    cardDescription: {
        textAlign: 'center',
        color: defaultPalette.typography.half,
    },
    cardHoverable: {
        transition: 'boxShadow .08s ease-in',
        '&:hover': {
            boxShadow: 'none',
        },
    },
    cardActionArea: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '1.25rem',
        borderRadius: '1rem',
        padding: '1rem',
        backgroundColor: 'transparent',
        transition: 'background .08s ease-in',
        '&:hover': {
            background: hexToRgba(defaultPalette.secondary.dark, 0.02),
        },
    },
    cardActionAreaDisabledHover: {
        cursor: 'default',
        '& .MuiCardActionArea-focusHighlight': {
            backgroundColor: 'transparent',
        },
        '&:hover': {
            background: 'transparent',
        },
    },
    cardAction: {
        width: '100%',
    },
    cardNoAction: {
        width: '100%',
        padding: '1rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: defaultPalette.secondary.ultraLight,
        color: defaultPalette.secondary.dark,
        borderRadius: '1rem',
    },
    cardNoActionWithEmail: {
        gap: '0.5rem',
    },
    buttonIcon: {
        width: '1.5rem',
        height: '1.5rem',
        fill: defaultPalette.white.main,
    },
    cardActionInnerContainer: {
        display: 'flex',
        gap: '7px',
    },
})
